// extracted by mini-css-extract-plugin
module.exports = {"image_input":"UploadForm_image_input__1IgKY","image_label":"UploadForm_image_label__aL3tA"};